import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

import Base from '../../utils/base'

export default function Slider(props) {
  var base = new Base()
  const {t, i18n} = useTranslation()

  const momentNow = moment()
  const [numGuests, setNumGuests] = useState(1)
  const [checkInDate, setCheckInDate] = useState(null)
  const [checkOutDate, setCheckOutDate] = useState(null)
  const [arrAmenities, setArrAmenities] = useState([
    {
      id: '',
      name: 'Air Conditioning',
    },
    {
      id: '',
      name: 'Disabled Access',
    },
    {
      id: '',
      name: 'Floor',
    },
    {
      id: '',
      name: 'Laundry Room',
    },
    {
      id: '',
      name: 'Gym',
    },
    {
      id: '',
      name: 'Alarm',
    },
    {
      id: '',
      name: 'Window Covering',
    },
    {
      id: '',
      name: 'WiFi',
    },
    {
      id: '',
      name: 'TV Cable',
    },
    {
      id: '',
      name: 'Dryer',
    },
    {
      id: '',
      name: 'Microwave',
    },
    {
      id: '',
      name: 'Washer',
    },
    {
      id: '',
      name: 'Refrigerator',
    },
    {
      id: '',
      name: 'Outdoor Shower',
    },
    {
      id: '',
      name: 'Garden',
    },
  ])
  const [arrCarousel, setArrCarousel] = useState([
    // {
    //   id: '',
    //   bgImage: 'url(assets/images/assets/Building Night.png?rnd=' + momentNow.format('HHmmss') + ')',
    //   subtitle: 'The best 5 star hotel',
    //   title: 'Find Your Luxury <br /> Rooms & Enjoy <span>Your Vacation</span>',
    //   video: 'https://www.youtube.com/watch?v=4jnzf1yj48M',
    //   image: 'assets/images/assets/Building Night.png?rnd=' + momentNow.format('HHmmss'),
    // },
    // {
    //   id: '',
    //   bgImage: 'url(assets/images/assets/Building.jpg?rnd=' + momentNow.format('HHmmss') + ')',
    //   subtitle: 'The best 5 star hotel',
    //   title: 'Find Your Luxury <br /> Rooms & Enjoy <span>Your Vacation</span>',
    //   video: 'https://www.youtube.com/watch?v=4jnzf1yj48M',
    //   image: 'assets/images/assets/Building.jpg?rnd=' + momentNow.format('HHmmss'),
    // },
  ])
  const [arrHomeBanner, setArrHomeBanner] = useState([])

  useEffect(() => {
    var lang = window.localStorage.getItem('lang')
		i18n.changeLanguage(lang != null ? lang : 'en')

    get_data()
    get_home_banner_data()
    setTimeout(() => {
      window.$('#checkin').datetimepicker({
        format: 'DD/MM/YYYY',
        allowInputToggle: true,
        minDate: moment(),
      })

      window.$('#checkout').datetimepicker({
        format: 'DD/MM/YYYY',
        allowInputToggle: true,
        minDate: moment(),
      })

      window.$('#checkin').on('change.datetimepicker', function(e) {
        setCheckInDate(moment(e.date))
      })
      window.$('#checkout').on('change.datetimepicker', function(e) {
        setCheckOutDate(moment(e.date))
      })

      
    }, 1000)
      
  }, [])

  useEffect(() => {
    if(checkInDate != null)
      reinit()
  }, [checkInDate])

  async function get_data() {
    var response = await base.request(base.url_api + '/banner/all?type=desktop')

    if(response != null){
      if(response.status == 'success'){
        for(let data of response.data){
          data.bgImage = "url(" + data.url_image + ")"
          data.image = data.url_image
        }
        setArrCarousel(response.data)
      }
      else
        base.show_error(response.message)
    }
  }

  async function get_home_banner_data() {
    var response = await base.request(base.url_api + '/home-banner/all?type=desktop')

    if(response != null){
      if(response.status == 'success'){
        for(let data of response.data){
          data.bgImage = "url(" + data.url_image + ")"
          data.image = data.url_image
        }
        setArrHomeBanner(response.data)
      }
      else
        base.show_error(response.message)
    }
  }

  function reinit(){
    window.$('#checkout').datetimepicker('destroy')

    window.$('#checkout').datetimepicker({
      format: 'DD/MM/YYYY',
      allowInputToggle: true,
      minDate: checkInDate,
    })

    window.$('#checkout').on('change.datetimepicker', function(e) {
      setCheckOutDate(moment(e.date))
    })
  }

  function decreaseGuest(){
    if(numGuests > 1)
      setNumGuests(numGuests - 1)
  }

  function increaseGuest(){
    setNumGuests(numGuests + 1)
  }

  function onSearchClicked(){
    window.open(`https://www.e1-booking.com/widget?id=zoom-hotels-jemursari&room_id=&checkin=${checkInDate.format('DD-MM-YYYY')}&checkout=${checkOutDate.format('DD-MM-YYYY')}`, '_blank')
  }

  return (
    <section className="main-slider-three">
      <div className="main-slider-three__carousel solinom-slick__carousel main-carousel d-block" style={{ zIndex: 0, }} data-slick-options='{
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "autoplay": true,
        "fade": true,
        "autoplaySpeed": 4000,
        "speed": 2000,
        "infinite": true,
        "arrows": false,
        "dots": false

      }'>
        {
          arrCarousel.map((carousel, index) => (
            <div className="main-slider-three__item" key={index}>
              <div className="main-slider-three__bg" style={{ backgroundImage: carousel.bgImage, }}></div>
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <div className="main-slider-three__content">
                      <h5 className="main-slider-three__sub-title" style={{ fontSize: '1rem', }}>{carousel.subtitle}</h5>
                      <div className="main-slider-three__box">
                        <h2 className="main-slider-three__title" style={{ fontSize: '3.75rem', }} dangerouslySetInnerHTML={{ __html: carousel.title }}></h2>
                      </div>
                      <div className="main-slider-three__video">
                        <a href={carousel.video} className="video-popup">
                          <i className="icon-polygon"></i>
                          <i className="ripple"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4" style={{  }}>
                    <div className="main-slider-three__thumb" style={{  }}>
                      <img src={carousel.image} alt="solinom image" style={{  }}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        }
      </div>
      
      <div className="main-slider-three__thumb-carousel w-100 position-absolute" style={{ bottom: 0,  }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8" style={{ overflowX: 'hidden', }}>
              <div className="main-slider-three__thumb__carousel solinom-slick__carousel w-100" data-slick-options='{
                "asNavFor": ".main-slider-three__carousel",
                "slidesToScroll": 1,
                "autoplay": false,
                "autoplaySpeed": 3000,
                "slidesToShow": 2,
                "infinite": true,
                "focusOnSelect": true,
                "dots": false,
                "arrows": false
						  }'>
                {
                  arrHomeBanner.map((banner, index) => (
                    <div className="main-slider-three__thumb__item" key={index}>
                      <img src={banner.url_image} alt="solinom thumb" />
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="banner-form" style={{ zIndex: 100, bottom: '-3rem', }}>
        <div className="banner-form__position wow fadeInUp" data-wow-delay="300ms">
          <div className="container">
            <form className="banner-form__wrapper d-inline-block w-100" action="#">
              <div className="row align-items-center w-100">
                <div className="col-12 col-lg-4" style={{ height: '100px', }}>
                  <div className="banner-form__control">
                    <label for="checkin">{t('check_in')}</label>
                    <input className="datetimepicker-input" id="checkin" type="text" data-toggle="datetimepicker" value={(checkInDate != null ? checkInDate : momentNow).format('DD/MM/YYYY')} data-target="#checkin"/>
                    <i className="icon-calendar-5-1"></i>
                  </div>
                </div>
                <div className="col-12 col-lg-4" style={{ height: '100px', }}>
                  <div className="banner-form__control">
                    <label for="checkout">{t('check_out')}</label>
                    <input className="datetimepicker-input" id="checkout" type="text" data-toggle="datetimepicker" value={(checkOutDate != null ? checkOutDate : momentNow).format('DD/MM/YYYY')} data-target="#checkout"/>
                    <i className="icon-calendar-5-1"></i>
                  </div>
                </div>
                {/* <div className="col-12 col-lg-3">
                  <div className="banner-form__control">
                    <label for="guests">{t('guest')}</label>
                    <div className="quantity-box">
                      <button type="button" className="sub" onClick={() => decreaseGuest()}><i className="fa fa-minus"></i></button>
                      <input id="guests" type="text" value={numGuests} onChange={(e) => setNumGuests(e.target.value)} />
                      <button type="button" className="add" onClick={() => increaseGuest()}><i className="icon-plus-1"></i></button>
                    </div>
                  </div>
                </div> */}
                {/* <div className="col-12 col-lg-3">
                  <div className="banner-form__control">
                    <label for="location">Location</label>
                    <select name="location" className="form-control border-0 p-0" style={{ width: '80%', lineHeight: '100%', }} id="location">
                      <option value="select">Where to Next? </option>
                      <option value="spain">Spain</option>
                      <option value="spain">Canada</option>
                      <option value="africa">Africa</option>
                      <option value="europe">Europe</option>
                      <option value="thailand">Thailand</option>
                      <option value="dubai">Dubai</option>
                      <option value="australia">Australia</option>
                      <option value="swizerlan">Swizerlan</option>
                    </select>
                    <i className="icon-pin-2"></i>
                  </div>
                </div> */}
                <div className="col-12 col-lg-4" style={{ height: '100px', }}>
                  <div className="banner-form__popup justify-content-end h-100">
                    {/* <button className="solinom-btn banner-form__filter">
                      <i className="icon-filter"></i>
                    </button> */}
                    
                    <button type="button" aria-label="search submit" onClick={() => onSearchClicked()} className="solinom-btn w-100 h-100 d-flex p-0 align-items-center justify-content-center" style={{ fontSize: '1rem', }}>
                      {/* <i className="icon-sharce"></i> */}
                      {t('navbar.bookNow')}
                    </button>
                  </div>
                </div>

                {/* <div className="explore__form-checkbox-list">
                  <div className="price-ranger">
                    <div className="ranger-min-max-block">
                      <div className="ranger-min-max-block__price">
                        <span>Price Range from</span>
                        <input type="text" readonly className="min" />
                        <span>To</span>
                        <input type="text" readonly className="max" />
                      </div>
                    </div>
                    <div id="slider-range"></div>
                  </div>

                  <div className="bedroom-filter">
                    <div className="box-select">
                      <label className="title-select">Bathrooms</label>
                      <select name="roomSize" className="form-control border-0 p-0" style={{ lineHeight: '100%', }} id="roomSize">
                        { [...Array(9)].map((x, index) => <option value={index + 1}>{index + 1}</option>) }
                      </select>
                    </div>
                    <div className="box-select">
                      <label className="title-select">Bedrooms</label>
                      <select name="roomSize" className="form-control border-0 p-0" style={{ lineHeight: '100%', }} id="roomSizeTwo">
                        { [...Array(9)].map((x, index) => <option value={index + 1}>{index + 1}</option>) }
                      </select>
                    </div>
                    <div className="box-select">
                      <label className="title-select">Type</label>
                      <select name="roomSize" className="form-control border-0 p-0" style={{ lineHeight: '100%', }} id="roomSizeThree">
                        { [...Array(9)].map((x, index) => <option value={index + 1}>{index + 1}</option>) }
                      </select>
                    </div>
                  </div>

                  <h3 className="banner-form__popup__title">Amenities:</h3>
                  <ul className="checkboxes list-unstyled">
                    {
                      arrAmenities.map((amenities, index) => (
                        <li>
                          <input id="check-2" type="checkbox" name="check" />
                          <label for="check-2">{amenities.name}</label>
                        </li>
                      ))
                    }
                  </ul>
                </div> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
